import React, { useState, useContext, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import PaginateList from "../../../utils/PaginateList";
import * as UserServices from "../../../../services/UserServices";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import moment from "moment-timezone";
import * as ViveroService from "../../../../services/ViveroService";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./userList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import { useUser } from "../hook/useUser";
import { converToTime } from "../../../../utils/formats/number";
import { PART_STATUS } from "../../../../constants/index";

const UserListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);
  const refresh = () => {
    setForceRefresh(true);
  };
  const { addUser } = useUser(refresh);
  const { changePasswordUser } = useUser(refresh);

  const getColumns = () => {
    const columns = [];
    columns.push({
      header: t("forms.user.table.heads.name"),
      accessorKey: "completeName",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.user.table.heads.email"),
      accessorKey: "email",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.user.table.heads.vivero"),
      accessorKey: "vivero.name",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.user.table.heads.active"),
      accessorKey: "active",
      cell: (info) => {
        if (info.getValue()) {
          return t("yes");
        }

        return t("no");
      },
    });
    columns.push({
      Header: " ",
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    });

    return columns;
  };

  // const goToEdit = (uuid) => {
  //   navigate(`/user/user/form/update/${uuid}`);
  // };

  // const showPart = (uuid) => {
  //   if (isTechnical) {
  //     navigate(`/technical/user/detail/${uuid}`);
  //   } else {
  //     navigate(`/user/workingPart/detail/${uuid}`);
  //   }
  // };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction
          onClick={() => handlerChangePassword(data.uuid)}
          type="button"
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </ButtonAction>

      </div>
    );
  };

  // const showDialogOnDelete = (uuid) => {
  //   const okAction = async () => {
  //     WorkingPartServices.deleteWorkingPart(uuid).then((result) => {
  //       if (result && result.deleted === true) {
  //         setForceRefresh(true);
  //       }
  //     });
  //   };

  //   const cancelAction = () => {};

  //   ShowAlertDialog(
  //     t("forms.workingPart.dialog.remove.title"),
  //     t("forms.workingPart.dialog.remove.text"),
  //     "warning",
  //     true,
  //     t("forms.workingPart.dialog.remove.buttonOk"),
  //     false,
  //     okAction,
  //     t("forms.workingPart.dialog.remove.buttonNo"),
  //     cancelAction
  //   );
  // };

  const handlerChangePassword = (uuid) => {
    changePasswordUser(uuid);
  };

  const createUser = async () => {
    addUser();
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-date";
    }
    const result = await UserServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={getColumns()}
        toList={listData}
        hideColum={hideColumn}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
      ></PaginateList>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11 d-flex justify-content-center">
          <button
            className="btn btn-secondary btn-md"
            onClick={() => createUser()}
          >
            {t("forms.users.buttons.new")}
          </button>
        </div>
      </div>
    </>
  );
};

UserListContainer.propTypes = {
  filters: PropTypes.object,
};

export default UserListContainer;
